import React from "react";
import { NavLink } from "react-router-dom";

import LogoImgWhite from "../../assets/images/logo-white.png";

const Navbar = ({ loggedIn }) => {
    let links;

    if (loggedIn !== undefined) {
        links = (
            <ul className="main-menu font-mountainsre" id="main-menu">
                {/* <li>
                    <NavLink to="/">Home</NavLink>
                </li> */}
                <li>
                    <NavLink to="/adminPanel">Admin Panel</NavLink>
                </li>
                <li>
                    <NavLink to="/logout">Logout</NavLink>
                </li>
            </ul>
        );
    } else {
        links = (
            <ul className="main-menu font-mountainsre" id="main-menu">
                <li>
                    <NavLink to="/">Home</NavLink>
                </li>
                <li>
                    <NavLink to="/">About Us</NavLink>
                </li>
                <li>
                    <NavLink to="/">Services</NavLink>
                </li>
                <li>
                    <NavLink to="/">Contact</NavLink>
                </li>
            </ul>
        );
    }
    return (
        <header>
            <div className="container">
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <a className="logo" href="#">
                    <img src={LogoImgWhite} alt="Logo" />
                </a>

                <div className="right-area">
                    <h6>
                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                        <NavLink
                            className="plr-20 color-white btn-fill-primary"
                            to="/order"
                        >
                            ORDER ONLINE
                        </NavLink>
                    </h6>
                </div>
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <a className="menu-nav-icon" data-menu="#main-menu" href="#">
                    <i className="ion-navicon" />
                </a>
                {links}
                <div className="clearfix" />
            </div>
        </header>
    );
};

export default Navbar;
